export default "__VITE_ASSET__DatyOWsP__"